/**
 * Heatmap definitions × periods. Cada celda coloreada por status,
 * con tooltip nativo (title) mostrando el valor.
 */
import { computeStatus, type KpiDefinition } from "@axorial/shared";

export function MetricHeatmap({
  definitions,
  periods,
  valueByDefAndPeriod,
}: {
  definitions: KpiDefinition[];
  periods: string[];
  valueByDefAndPeriod: Map<string, Map<string, number | null>>;
}) {
  if (definitions.length === 0) {
    return <div className="text-sm text-base-content/55 italic">Sin métricas para mostrar.</div>;
  }

  return (
    <div className="overflow-x-auto card-elevated p-3">
      <table className="text-xs">
        <thead>
          <tr>
            <th className="text-left pr-3 sticky left-0 bg-base-100 z-10">Métrica</th>
            {periods.map((p) => (
              <th key={p} className="px-1 text-base-content/55 font-mono">
                {p.slice(5)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {definitions.map((d) => (
            <tr key={d.id}>
              <td className="pr-3 py-1 sticky left-0 bg-base-100 z-10 whitespace-nowrap">
                <span className="text-base-content/80 font-medium">{d.name}</span>
              </td>
              {periods.map((period) => {
                const v = valueByDefAndPeriod.get(d.id)?.get(period) ?? null;
                const status = computeStatus(v, d);
                const bg =
                  status === "good"
                    ? "bg-success/55"
                    : status === "improvable"
                      ? "bg-warning/55"
                      : status === "bad"
                        ? "bg-error/55"
                        : "bg-base-300/30";
                return (
                  <td key={period} className="px-1 py-1">
                    <div
                      className={`size-5 rounded-sm ${bg}`}
                      title={`${d.name} · ${period}: ${v == null ? "sin dato" : v}`}
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
